// routes/index.js
import { Navigate, useRoutes } from "react-router-dom";
import sportsRoutes from "../containers/Sports/route"; // your sports routes array import
import NotFound from "../components/NotFound";
import eventsRoutes from "@/containers/events-category/route";
import { Suspense, lazy } from "react";
import { SkeletonPage } from "@/components/SkeletonLoaders";
import salonRoutes from "@/containers/salon/route";
import foodRoutes from "@/containers/food-category/route";
import carWashRoutes from "@/containers/car-wash/route";
import fitnessRoutes from "@/containers/fitness/route";
import laundryRoutes from "@/containers/laundry/route";
import homeServicesRoutes from "@/containers/home-services/route";
import {
  // auth and verify
  AadhaarVerify,
  SignIn,
  SignUp,
  // booking
  BookingCancel,
  MyBookings,
  OtpVerify,
  // dashboard
  ProviderDashboard,
  ListAllPost,
  UserProfile,
  ReportPost,
  CreatePost,
  UserConnections,
} from "./elements";
const KcoinsDashboard = lazy(() =>
  import("../components/kcoins/KCoinsDashboard")
);
const UserReferral = lazy(() => import("../components/UserReferral"));
const BlockSlot = lazy(() => import("../components/block-slot"));

const VoucherPage = lazy(() => import("../components/vouchers/VoucherPage"));

const routes = [
  {
    path: "/",
    index: true,
    element: <Navigate to="/events" replace />,
  },
  {
    path: "/my-vouchers",
    element: (
      <Suspense fallback={<SkeletonPage />}>
        <VoucherPage />
      </Suspense>
    ),
  },
  // bookings
  {
    path: "/my-bookings",
    element: (
      <Suspense fallback={<SkeletonPage />}>
        <MyBookings />
      </Suspense>
    ),
  },
  {
    path: "/cancel-booking",
    element: (
      <Suspense fallback={<SkeletonPage />}>
        <BookingCancel />
      </Suspense>
    ),
  },
  // dashboard
  {
    path: "/provider-dashboard/:provider_id",
    element: (
      <Suspense fallback={<SkeletonPage />}>
        <ProviderDashboard />
      </Suspense>
    ),
  },
  // auth and verify
  {
    path: "/signin",
    element: (
      <Suspense fallback={<SkeletonPage />}>
        <SignIn />
      </Suspense>
    ),
  },
  {
    path: "/signup",
    element: (
      <Suspense fallback={<SkeletonPage />}>
        <SignUp />
      </Suspense>
    ),
  },
  {
    path: "/verify-otp",
    element: (
      <Suspense fallback={<SkeletonPage />}>
        <OtpVerify />
      </Suspense>
    ),
  },
  {
    path: "/aadhaar-verification-success/callback",
    element: (
      <Suspense fallback={<SkeletonPage />}>
        <AadhaarVerify />
      </Suspense>
    ),
  },
  {
    path: "/dashboard/my-kcoins",
    element: (
      <Suspense fallback={<SkeletonPage />}>
        <KcoinsDashboard />
      </Suspense>
    ),
  },
  {
    path: "/dashboard/my-referrals",
    element: (
      <Suspense fallback={<SkeletonPage />}>
        <UserReferral />
      </Suspense>
    ),
  },
  {
    path: "/provider/block-slots/:provider_id",
    element: (
      <Suspense fallback={<SkeletonPage />}>
        <BlockSlot />
      </Suspense>
    ),
  },
  // community
  {
    path: "/community",
    children: [
      {
        index: true,
        element: <Navigate to="/community/post" replace />,
      },
      {
        path: "post",
        element: (
          <Suspense fallback={<SkeletonPage />}>
            <ListAllPost />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "/community/profile",
    element: (
      <Suspense fallback={<SkeletonPage />}>
        <UserProfile />
      </Suspense>
    ),
  },

  {
    path: "/community/report",
    element: (
      <Suspense fallback={<SkeletonPage />}>
        <ReportPost />
      </Suspense>
    ),
  },
  {
    path: "/community/post/create",
    element: (
      <Suspense fallback={<SkeletonPage />}>
        <CreatePost />
      </Suspense>
    ),
  },
  {
    path: "/community/user-connections/:tab?",
    element: (
      <Suspense fallback={<SkeletonPage />}>
        <UserConnections />
      </Suspense>
    ),
  },

  // modules
  ...sportsRoutes,
  ...eventsRoutes,
  ...salonRoutes,
  ...foodRoutes,
  ...carWashRoutes,
  ...fitnessRoutes,
  ...laundryRoutes,
  ...homeServicesRoutes,
  {
    path: "not-found",
    element: <NotFound />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default function AppRouter() {
  const element = useRoutes(routes);
  return element;
}
